import { TextInput } from '@common/ui'
import { LocalNext } from '../../domain/form/definition/LocalNext'
import NextOption from '../input/NextOption'

export type NextElementType = 'page' | 'item'

export type NextElementDisplayProps = {
  value?: LocalNext
  options?: readonly NextOption[]
  type: NextElementType
}

const NextElementDisplay: React.FC<NextElementDisplayProps> = ({ value, options = [], type }) => {
  const defaultText = type === 'page' ? 'Next page' : 'Next item'

  const currentOption = value ? options?.find((o) => o.next.key === value.key)?.label : undefined
  const hasError = value && !currentOption

  return (
    <TextInput
      disabled
      label="Go to"
      value={currentOption ?? value?.key ?? defaultText}
      error={hasError ? `Invalid ${value?.type ?? ''} selected` : undefined}
      style={{ minWidth: 200 }}
    />
  )
}

export default NextElementDisplay
